<template>
	<div>
    <side-bar>
      <template v-slot:header>
          <v-icon>event</v-icon>
          <v-toolbar-title style="font-size: 16px;">Select events</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="$is_admin()" fab small flat @click="add_own_todo_events"><v-icon>filter</v-icon></v-btn>
      </template>

      <template v-slot:subheader>
        <v-text-field
          flat
          label="Search"
          prepend-inner-icon="search"
          solo
          hide-details
          v-model="search"
          color="deep-orange"
        ></v-text-field>
      </template>

      <v-list dense two-line>
          <template v-for="event in filtered_events">
            <v-list-tile @click.stop="toggleEventFilter(event)">
              <v-list-tile-content :class="{'grey--text text--darken-1': !is_running(event)}">
                <v-list-tile-title>{{name(event)}}</v-list-tile-title>
                <v-list-tile-sub-title class="grey--text" :class="{'text--darken-1': is_running(event)}">{{time(event)}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon v-if="is_visible(event)" color="#f8d84a">fa-eye</v-icon>
                <v-icon v-if="!is_visible(event)">fa-eye-slash</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </template>
      </v-list>
    </side-bar>



<!--
		<v-card flat>
        <v-toolbar :dark="$dark()" light flat dense extended>
          <template slot="extension">
            <v-text-field v-model="search" hide-details prepend-icon="search" single-line style="min-height: 25px; padding-top: 0;"></v-text-field>
          </template>
        	<v-icon>event</v-icon>
          <v-toolbar-title style="font-size: 16px;">Select events</v-toolbar-title>
          <v-btn v-if="$is_admin()" fab small flat @click="add_own_todo_events"><v-icon>filter</v-icon></v-btn>
        </v-toolbar>

        <v-list dense two-line>
          <template v-for="event in filtered_events">
            <v-list-tile @click.stop="toggleEventFilter(event)">
              <v-list-tile-content :class="{'grey--text text--darken-1': !is_running(event)}">
                <v-list-tile-title>{{name(event)}}</v-list-tile-title>
                <v-list-tile-sub-title class="grey--text" :class="{'text--darken-1': is_running(event)}">{{time(event)}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon v-if="is_visible(event)" color="red">fa-eye</v-icon>
                <v-icon v-if="!is_visible(event)">fa-eye-slash</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>-->
  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import EventModel from '@/models/event.js'
import SideBar from '@/components/SideBar.vue'

export default {
  components: {
    SideBar
  },
	data () {
    var start_date = moment().startOf('day').toDate();
    var end_date = moment().endOf('day').toDate();
		return {
      channel: undefined,
      events: [],
      filters: {
        daterange: {
          start: start_date,
          end: end_date
        },
        states: ["active"]
      },
      ts: this.$store.state.timestamp,
      on_init_ref: undefined,
      on_events_ref: undefined,
      on_event_update_ref: undefined,
      search: ""
		}
	},
  computed: {
    filtered_events() {
      if(this.search.length < 1) {
        return _.sortBy(this.events, function(o) { return [o.cached_start_time] });
      }
      return _.sortBy(_.filter(this.events, (event) => {
        return this.name(event).toLowerCase().includes(this.search.toLowerCase());
      }), function(o) { return [o.cached_start_time] })
    },
		multiview_filters () {
			return this.$store.state.account.meta.multiview_event_filter || [];
		}
  },
  methods: {
    is_running(e) {
      return e.cached_start_time <= this.ts && e.cached_end_time >= this.ts;
    },
    name(event) {
      return EventModel.title(event);
    },
    time(event) {
      return this.format_date(event.cached_start_time)
    },
    is_visible(event) {
      return typeof(_.find(this.multiview_filters, (uuid) => { return uuid == event.uuid; })) != "undefined";
    },
    format_date (v) {
      return datelib.format_date(v) + " - " + datelib.format_time(v);
    },
    filterEvents () {
      var _filters = _.cloneDeep(this.filters);
      if(typeof(_filters.daterange.start) != "undefined") {
        _filters.daterange.start = moment(_filters.daterange.start).startOf('day').unix();
      }
      if(typeof(_filters.daterange.end) != "undefined") {
        _filters.daterange.end = moment(_filters.daterange.end).endOf('day').unix();
      }
      this.channel.push("filter", _filters);
    },
    add_own_todo_events() {
      var self = this;
      var acc = _.cloneDeep(this.$store.state.account);
      _.each(this.events, function(event) {
        if (EventModel.is_todo_list(event, acc) == true) {
          console.log(event.event_group);
          acc.meta.multiview_event_filter.push(event.uuid);
        }
      });
      acc.meta.multiview_event_filter = _.uniq(acc.meta.multiview_event_filter);
      this.$store.dispatch("update_profile", acc);      
    },
    toggleEventFilter(event) {
			var acc = _.cloneDeep(this.$store.state.account);
			acc.meta.multiview_event_filter = _.xor(acc.meta.multiview_event_filter, [event.uuid]);
			this.$store.dispatch("update_profile", acc);
    },
    connect_ws () {
      var self = this;
      this.channel = this.$cloudserver.channel("events:all", false);
      this.on_init_ref = this.channel.on("init", function(msg) {
        self.filterEvents();
      });
      this.on_events_ref = this.channel.on("events", function(msg) {
        self.ts = self.$store.state.timestamp;
        self.events = msg.events;
				self.$store.dispatch("get_profile").then(() => {
					var acc = _.cloneDeep(self.$store.state.account);
					var uuids = _.map(self.events, "uuid");
	        acc.meta.multiview_event_filter = _.filter(acc.meta.multiview_event_filter, (filter) => { return uuids.indexOf(filter) != -1; });
					self.$store.dispatch("update_profile", acc);
				}, () => {});
      });
      this.on_event_update_ref = this.channel.on("event-update", function(msg) {
        self.filterEvents();
      });
      this.channel.join();
    }
  },
  mounted () {
		this.$store.dispatch("get_profile").then(() => {
	    this.$nextTick(() => {
	      this.connect_ws();
	    });
		}, () => {});
    var self = this;
    self.ts = self.$store.state.timestamp || moment().unix();
    this.interval = setInterval(() => {
      self.ts = self.$store.state.timestamp;
    },10000);
  },
  beforeDestroy: function() {
    this.channel.off("init", this.on_init_ref);
    this.channel.off("events", this.on_events_ref);
    this.channel.off("event-update", this.on_event_update_ref);
    this.channel.leave();
  }
}
</script>
